import Peer from 'peerjs';
import { store } from "./Store/config.js"
import tvConnectionSlice from './Store/TVConnection/slice.js';
let peer
let connection
export const initPeer = (onConnection) => {
  peer = new Peer("123456", {
    host: "api.rippletv.io",
    port: 50070,
    path: '/myapp',
  });

  peer.on('open', id => {
    // alert("My peer ID is" + id)
    alert(JSON.stringify(Object.keys(window)))
  });

  peer.on('close', () => {
    // alert("closed")
    store.dispatch(tvConnectionSlice.actions.setIsTVConnected(false))
  })


  peer.on('disconnected', () => {
    store.dispatch(tvConnectionSlice.actions.setIsTVConnected(false))
    // alert("disconnected")
  })


  peer.on('connection', conn => {
    // alert("connection")
    connection = conn
    conn.on('close', () => {
      store.dispatch(tvConnectionSlice.actions.setIsTVConnected(false))
      peer.disconnect()
      // console.log("closed");
      // alert("connection closed")
    })

    conn.on('open', function () {
      // console.log('connection: ');
      // alert("connection opened")
      onConnection()
      conn.on('error', function(err){
        // alert("conn error", err.toString())
      })
      conn.on('data', function (data) {
        // console.log('Received', data);
        store.dispatch(tvConnectionSlice.actions.setAction(data))
      });
    });

  });

  peer.on('error', err => {
    // console.log('error:peer ' + err);
    alert("peer error____   " + JSON.stringify(err))
  });
}

export const closePeer = () => {
  peer.disconnect()
  connection.close()
  // alert("peer closed")
} 